import { takeLatest, put, call, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { getPageAggregator } from 'yoda-interfaces/lib/IrisPage/IrisPage';
import {
    GET_CASHPASS_EXCLUSIONS,
    GET_CASHPASS_EXCLUSIONS_SUCCESS,
    GET_CASHPASS_EXCLUSIONS_ERROR,
} from '../actionTypes/CashpassExclusionsActionTypes';

const getCashpassExclusionsState = (state) => state.cashpassExclusions;

// Path segment appended to the content-aggregator aggregate-pages base
// (/content-aggregator/aggregate-pages) by getPageAggregator.
const EXCLUSIONS_PARAMS = '/m/rewards-redemptions-exclusions';

export function* cashpassExclusionsSaga() {
    try {
        // Fetch once: skip if the content is already loaded OR a previous
        // attempt already ran (success or error). This prevents infinite
        // retries when the API keeps erroring.
        const exclusionsState = yield select(getCashpassExclusionsState);
        if (get(exclusionsState, 'isLoaded') || get(exclusionsState, 'hasAttempted')) {
            return;
        }

        // Reuse the same IRIS content-aggregator flow the rest of the app uses.
        // aggregateAPI: true selects the AGGREGATOR_API base
        // (/content-aggregator/aggregate-pages), so the final URL is
        // /content-aggregator/aggregate-pages/m/rewards-redemptions-exclusions.
        // getPageAggregator returns an object shaped like { data, status, cacheControl }.
        const aggregatorResponse = yield call(getPageAggregator, {
            params: EXCLUSIONS_PARAMS,
            aggregateAPI: true,
        });
        const content = get(aggregatorResponse, 'data', null);
        const status = get(aggregatorResponse, 'status');

        if (content && (!status || status < 300)) {
            yield put({ type: GET_CASHPASS_EXCLUSIONS_SUCCESS, content });
        } else {
            throw aggregatorResponse || new Error('No content returned');
        }
    } catch (error) {
        yield put({ type: GET_CASHPASS_EXCLUSIONS_ERROR, error });
    }
}

export default function* watchCashpassExclusionsSaga() {
    yield takeLatest(GET_CASHPASS_EXCLUSIONS, cashpassExclusionsSaga);
}

watchCashpassExclusionsSaga.sagaName = 'cashpassExclusionsSaga';
